import { Type } from 'class-transformer';

// Model imports
import { BlockIssuesResultDto } from './block-issues-result-dto';
import { ConveyanceClosingPaperCommunitiesResultDto } from './conveyance-closing-paper-communities-result-dto';
import { ConveyanceCommunityTransferAccountRawDto } from './conveyance-community-transfer-account-raw-dto';
import { ConveyanceOwnershipHistoryResultDto } from './conveyance-ownership-history-result-dto';
import { ConveyancePropertyInfoResultDto } from './conveyance-property-info-result-dto';
import { ConveyanceSellerInfoResultDto } from './conveyance-seller-info-result-dto';

export class ConveyanceWelcomeEditorResultDto {
    @Type(() => ConveyancePropertyInfoResultDto)
    property: ConveyancePropertyInfoResultDto;

    @Type(() => ConveyanceSellerInfoResultDto)
    seller: ConveyanceSellerInfoResultDto;

    @Type(() => ConveyanceOwnershipHistoryResultDto)
    ownershipHistory: ConveyanceOwnershipHistoryResultDto[];

    @Type(() => ConveyanceClosingPaperCommunitiesResultDto)
    closingPaperCommunities: ConveyanceClosingPaperCommunitiesResultDto[];

    @Type(() => ConveyanceCommunityTransferAccountRawDto)
    conveyanceCommunityTransferAccount: ConveyanceCommunityTransferAccountRawDto;

    @Type(() => BlockIssuesResultDto)
    blockIssues: BlockIssuesResultDto[];

    flaggedForCollectionMessage: string;
}
